import { Formik } from 'formik';
import React from 'react';
import * as yup from 'yup';
import { Col, Row } from 'react-bootstrap';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import SubmitButton from 'Shared/form/SubmitButton';
import AssessmentService from 'App/services/AssessmentService';
import toast from 'Shared/toast';
import AssessmentPublisherForm from './AssessmentPublisherForm';
import { queryClient } from 'Shared/queryClient';

const validationSchema = yup.object().shape({
    selectedRecords: yup.array().required().min(1),
});

const initialValues = {
    availableRecords: [],
    selectedRecords: [],
    rawList: [],
    selectedTherapy: null,
};

const AssessmentPublisher = () => {
    return (
        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            validateOnMount
            onSubmit={async (values, { setSubmitting }) => {
                if (!values.selectedRecords || values.selectedRecords.length === 0) {
                    setSubmitting(false);
                    return;
                }

                try {
                    const results = await Promise.all(
                        values.selectedRecords.map(async (assessment) => {
                            const response = await AssessmentService.publishAssessment(assessment.id);
                            return { assessment, response };
                        })
                    );

                    let successCount = 0;

                    results.forEach(({ assessment, response }) => {
                        const hasFailure = Object.values(response || {}).some((val) => val === false);

                        if (hasFailure) {
                            toast.error(`${assessment.name} failed to publish. Please contact support`);
                        } else {
                            successCount += 1;
                        }
                    });

                    if (successCount > 0) {
                        toast.success(`${successCount} assessments published successfully.`);
                        await queryClient.invalidateQueries(['assessmentPublisherList']);
                    }
                } catch (err) {
                    toast.error(err?.data || 'Failed to publish assessments');
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {({ handleSubmit }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <AssessmentPublisherForm />
                    <Row>
                        <Col md={12}>
                            <FormButtonGroup>
                                <SubmitButton>Publish Assessments</SubmitButton>
                            </FormButtonGroup>
                        </Col>
                    </Row>
                </form>
            )}
        </Formik>
    );
};

export default AssessmentPublisher;
